import {
  IconBook2,
  IconBuildingStore,
  IconFlask,
  IconHistory,
  IconInbox,
  IconKey,
  IconLayoutDashboard,
  IconListDetails,
  IconMail,
  IconMailForward,
  IconMessages,
  IconSettings,
  IconShieldLock,
  IconTargetArrow,
  IconTerminal2,
  IconUsers,
  type Icon,
} from '@tabler/icons-react';

export interface NavItem {
  to: string;
  label: string;
  icon: Icon;
  /** What the page is for. Shown as a hint in search. */
  hint: string;
  end?: boolean;
  /** Hidden when the signed-in user lacks it. Presentation only. */
  permission?: string;
}

/** Single source for the sidebar, the breadcrumbs and the search palette. */
export const NAV: NavItem[] = [
  { to: '/app', label: 'Overview', icon: IconLayoutDashboard, hint: 'Live state of the integration', end: true, permission: 'dealers:read' },
  { to: '/app/dealers', label: 'Dealerships', icon: IconBuildingStore, hint: 'Connected stores and their setup', permission: 'dealers:read' },
  { to: '/app/leads', label: 'Leads', icon: IconInbox, hint: 'Leads collected from each dealership', permission: 'leads:read' },
  { to: '/app/opportunities', label: 'Opportunities', icon: IconTargetArrow, hint: 'Opportunities those leads created', permission: 'leads:read' },
  { to: '/app/audit', label: 'CRM audit', icon: IconListDetails, hint: 'Every CRM API call, with Request-Ids', permission: 'audit:read' },
  { to: '/app/activity', label: 'Activity', icon: IconHistory, hint: 'Who changed what in the console', permission: 'activity:read' },
  { to: '/app/keys', label: 'API keys', icon: IconKey, hint: 'Keys for the voice-agent action API', permission: 'keys:manage:own' },
  { to: '/app/playground', label: 'Playground', icon: IconTerminal2, hint: 'Try the action API from the browser', permission: 'keys:manage:own' },
  { to: '/app/emails', label: 'Emails', icon: IconMessages, hint: 'Email conversations: what we sent and what customers wrote back', permission: 'leads:read' },
  { to: '/app/email-lab', label: 'Email lab', icon: IconFlask, hint: 'Try the email agent on made-up leads and replies', permission: 'dealers:config' },
  // Docs are reference material; anyone signed in may read them.
  { to: '/app/docs', label: 'API docs', icon: IconBook2, hint: 'Action API reference' },
  { to: '/app/users', label: 'Users', icon: IconUsers, hint: 'Console and portal accounts', permission: 'users:manage' },
  { to: '/app/invitations', label: 'Invitations', icon: IconMailForward, hint: 'Invite staff or a dealership', permission: 'users:manage' },
  { to: '/app/roles', label: 'Roles', icon: IconShieldLock, hint: 'What each role may do', permission: 'roles:manage' },
  { to: '/app/email', label: 'Email', icon: IconMail, hint: 'Email providers and senders', permission: 'email:manage' },
  { to: '/app/settings', label: 'Settings', icon: IconSettings, hint: 'Fortellis and Cox environment', permission: 'settings:manage' },
];
